define('entities/admin/color_selections',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  // Colour selections of the account: the palettes an imprint technology offers
  // in the editor (backend ColorSelectionController, v2/colorselections/**).
  var ColorSelection = Backbone.Model.extend({
    defaults: {
      secId: null,
      code: '',
      name: '',
      description: '',
      colorCount: 0,
      colors: [],
      techniques: []
    },
    idAttribute: 'secId'
  });

  // Settings.url does not encode values ("PANTONE SOLID COATED", "185 C").
  var url = function (path, params) {
    var encoded = {};
    _.each(params || {}, function (value, key) {
      if (value !== undefined && value !== null && value !== '') {
        encoded[key] = encodeURIComponent(value);
      }
    });
    return Settings.url('compuzz2', 'v2/colorselections' + (path || ''), encoded);
  };

  var send = function (type, target, json) {
    var defer = $.Deferred();
    $.ajax({
      type: type,
      url: target,
      contentType: 'application/json',
      data: json ? JSON.stringify(json) : undefined,
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  };

  App.reqres.setHandler('colorSelections:model', function (json) {
    return new ColorSelection(json);
  });

  // -> [{secId, code, name, description, colorCount, colors: [{library, code, name, hex}], techniques: [...]}]
  App.reqres.setHandler('colorSelections:list', function (search) {
    return send('GET', url('/details', search ? { search: search } : null));
  });

  App.reqres.setHandler('colorSelections:get', function (secId) {
    return send('GET', url('/' + secId));
  });

  App.reqres.setHandler('colorSelections:create', function (json) {
    return send('POST', url(), json);
  });

  App.reqres.setHandler('colorSelections:update', function (secId, json) {
    return send('PUT', url('/' + secId), json);
  });

  App.reqres.setHandler('colorSelections:delete', function (secId) {
    return send('DELETE', url('/' + secId));
  });

  // Spot colours of every library -> [{library, code, name, hex}]
  App.reqres.setHandler('colorSelections:pantones', function (params) {
    return send('GET', url('/pantones', params));
  });

  App.reqres.setHandler('colorSelections:libraries', function () {
    return send('GET', url('/pantones/libraries'));
  });

  // Spot libraries of the account (then shared ones holding its colours)
  // -> [{secId, name, shared, colorCount}]
  App.reqres.setHandler('colorSelections:spot-libraries', function () {
    return send('GET', url('/libraries'));
  });

  App.reqres.setHandler('colorSelections:spot-library:create', function (json) {
    return send('POST', url('/libraries'), json);
  });

  App.reqres.setHandler('colorSelections:spot-library:rename', function (secId, json) {
    return send('PUT', url('/libraries/' + secId), json);
  });

  App.reqres.setHandler('colorSelections:spot-library:delete', function (secId) {
    return send('DELETE', url('/libraries/' + secId));
  });

  // -> [{secId, code, name, hex, c, m, y, k, usedCount}]
  App.reqres.setHandler('colorSelections:spot-colors', function (librarySecId) {
    return send('GET', url('/libraries/' + librarySecId + '/colors'));
  });

  App.reqres.setHandler('colorSelections:spot-color:create', function (librarySecId, json) {
    return send('POST', url('/libraries/' + librarySecId + '/colors'), json);
  });

  App.reqres.setHandler('colorSelections:spot-color:update', function (librarySecId, secId, json) {
    return send('PUT', url('/libraries/' + librarySecId + '/colors/' + secId), json);
  });

  App.reqres.setHandler('colorSelections:spot-color:delete', function (librarySecId, secId) {
    return send('DELETE', url('/libraries/' + librarySecId + '/colors/' + secId));
  });

  App.reqres.setHandler('colorSelections:export-url', function () {
    return url('/export');
  });

  // -> {selectionsCreated, selectionsUpdated, selectionsSkipped, colors, techniquesLinked,
  //     techniquesUnlinked, techniquesUpdated, errors: [{sheet, line, label, message}], warnings: [...]}
  App.reqres.setHandler('colorSelections:import', function (file) {
    var defer = $.Deferred();
    var formData = new FormData();
    formData.append('file', file, file.name);
    $.ajax({
      type: 'POST',
      url: url('/import'),
      data: formData,
      processData: false,
      contentType: false,
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

